// extracted by mini-css-extract-plugin
export default {"word_wrapper":"styles-module__word_wrapper--hA9FE","suggestion_button":"styles-module__suggestion_button--m9yBu"};